import { Component, input, model, OnInit, output } from '@angular/core';
import { ExpandedPaperExtra } from '../../../models/client-models/entities/expanded-paper-extra';
import { PaperExtraType } from '../../../models/server-models/enums/paper-extra-type';

@Component({
  selector: 'app-extras-selection',
  templateUrl: './extras-selection.component.html',
  styleUrls: ['./extras-selection.component.scss'],
  standalone: false,
})
export class ExtrasSelectionComponent implements OnInit {
  selectedPaperExtras = model<ExpandedPaperExtra[]>([]);

  paperExtras = input.required<ExpandedPaperExtra[]>();

  doNextStep = output<void>();

  constructor() {}

  ngOnInit() {}

  isSelected(extra: ExpandedPaperExtra): boolean {
    return this.selectedPaperExtras().some((selected) => selected.id === extra.id);
  }

  isDisabled(extra: ExpandedPaperExtra): boolean {
    // If this extra is already selected, it's not disabled
    if (this.isSelected(extra)) {
      return false;
    }

    // Check if selecting this extra would conflict with existing selections
    if (extra.type === PaperExtraType.Frame) {
      // Frame cannot be selected if Lamination or Binding is already selected
      return this.selectedPaperExtras().some(selected => 
        selected.type === PaperExtraType.Lamination || 
        selected.type === PaperExtraType.Binding
      );
    }

    if (extra.type === PaperExtraType.Lamination) {
      // Lamination cannot be selected if Frame is already selected
      return this.selectedPaperExtras().some(selected => selected.type === PaperExtraType.Frame);
    }

    if (extra.type === PaperExtraType.Binding) {
      // Binding cannot be selected if Frame is already selected
      return this.selectedPaperExtras().some(selected => selected.type === PaperExtraType.Frame);
    }

    return false;
  }

  toggleExtra(extra: ExpandedPaperExtra): void {
    // Don't allow toggling if the extra is disabled
    if (this.isDisabled(extra)) {
      return;
    }

    if (!this.isSelected(extra)) {
      this.selectedPaperExtras.set([...this.selectedPaperExtras(), extra]);
    } else {
      this.selectedPaperExtras.set(this.selectedPaperExtras().filter((selected) => selected.id !== extra.id));
    }
  }

  skipExtras() {
    this.doNextStep.emit();
  }
}
